import { Box, Image } from '@chakra-ui/react';
import logo from '../assets/pm-logo-default.svg';

function FullPageForm({ ...props }) {
    return (
        <Box
            position="absolute"
            width="100%"
            height={{ base: '100%', lg: '100vh' }}
            display="flex"
            flexDirection="column"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="center"
            backgroundColor="#f4f4f6"
            paddingBottom="8vh"
            paddingX="20px"
        >
            <Image width="32px" margin="24px" src={logo} alt="Logo" />
            <Box
                display="flex"
                flexDirection="column"
                textAlign="center"
                alignItems="center"
                paddingX={{ base: '16px', lg: '28px' }}
                paddingY={{ base: '12px', lg: '24px' }}
                borderRadius="28px"
                borderWidth={{ base: '0px', lg: '1px' }}
                width={{ base: '100%', lg: '500px' }}
                bg="white"
                {...props}
            ></Box>
        </Box>
    );
}

export default FullPageForm;
